import '../styles/Dashboard/dashboardStyle.css';

export const Loading = () => (
  <div className="loading">
    <div></div>
    <div></div>
  </div>
);
